/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-12-31 10:34:17
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_internalH5';
import { type } from './interface';
import axios from 'axios';
import { host } from './http'
import store from '../vuex/modules/login';
import qs from 'qs';
export namespace Operations {
    /**
     * 会员登录
     */
    export var Login = (body: any): Promise<any> => {
        return Post(`/api/Operations/Login`, body);
    };
    /**
     * 支付信息存根列表
     */
    export var GetTbPayResultList = (body: any): Promise<any> => {
        return Get(`/api/Operations/GetTbPayResultList`, body);
    };
    
}



// WEBPACK FOOTER //
// ./src/http/api_Operations.ts